import './dropdown.css';
export default {
  "badge": "pf-v5-c-badge",
  "check": "pf-v5-c-check",
  "divider": "pf-v5-c-divider",
  "dropdown": "pf-v5-c-dropdown",
  "dropdownGroup": "pf-v5-c-dropdown__group",
  "dropdownGroupTitle": "pf-v5-c-dropdown__group-title",
  "dropdownMenu": "pf-v5-c-dropdown__menu",
  "dropdownMenuItem": "pf-v5-c-dropdown__menu-item",
  "dropdownMenuItemDescription": "pf-v5-c-dropdown__menu-item-description",
  "dropdownMenuItemIcon": "pf-v5-c-dropdown__menu-item-icon",
  "dropdownMenuItemMain": "pf-v5-c-dropdown__menu-item-main",
  "dropdownToggle": "pf-v5-c-dropdown__toggle",
  "dropdownToggleButton": "pf-v5-c-dropdown__toggle-button",
  "dropdownToggleCheck": "pf-v5-c-dropdown__toggle-check",
  "dropdownToggleIcon": "pf-v5-c-dropdown__toggle-icon",
  "dropdownToggleImage": "pf-v5-c-dropdown__toggle-image",
  "dropdownToggleProgress": "pf-v5-c-dropdown__toggle-progress",
  "dropdownToggleText": "pf-v5-c-dropdown__toggle-text",
  "menu": "pf-v5-c-menu",
  "modifiers": {
    "fullHeight": "pf-m-full-height",
    "expanded": "pf-m-expanded",
    "action": "pf-m-action",
    "disabled": "pf-m-disabled",
    "plain": "pf-m-plain",
    "text": "pf-m-text",
    "splitButton": "pf-m-split-button",
    "primary": "pf-m-primary",
    "inProgress": "pf-m-in-progress",
    "active": "pf-m-active",
    "secondary": "pf-m-secondary",
    "top": "pf-m-top",
    "static": "pf-m-static",
    "alignRight": "pf-m-align-right",
    "alignLeft": "pf-m-align-left",
    "alignRightOnSm": "pf-m-align-right-on-sm",
    "alignLeftOnSm": "pf-m-align-left-on-sm",
    "alignRightOnMd": "pf-m-align-right-on-md",
    "alignLeftOnMd": "pf-m-align-left-on-md",
    "alignRightOnLg": "pf-m-align-right-on-lg",
    "alignLeftOnLg": "pf-m-align-left-on-lg",
    "alignRightOnXl": "pf-m-align-right-on-xl",
    "alignLeftOnXl": "pf-m-align-left-on-xl",
    "alignRightOn_2xl": "pf-m-align-right-on-2xl",
    "alignLeftOn_2xl": "pf-m-align-left-on-2xl",
    "ariaDisabled": "pf-m-aria-disabled",
    "icon": "pf-m-icon",
    "description": "pf-m-description"
  },
  "spinner": "pf-v5-c-spinner",
  "themeDark": "pf-v5-theme-dark"
};